/**
 * Every callable in this app lives in europe-west1, NOT the SDK's default.
 *
 * getFunctions(app) with no region silently targets us-central1, where none of
 * these functions exist. The failure is invisible from the client — the call
 * simply errors and the UI shows its generic "something went wrong", while the
 * Cloud Functions log records no invocation at all, because the request never
 * reached the right region. Found by running the app: tapping "أرسل الرمز"
 * failed with an empty server-side log.
 *
 * Firestore is in europe-west1 too; see functions/index.js for why neither
 * could stay in Dammam.
 */
export const FUNCTIONS_REGION = 'europe-west1';
